import 'css-chunksrc/client/pages/projectPage/budgetPage/expensesTable/expense/attachmentsCount/styles.scss';export default {
  "commentsCount": "_commentsCount_19hmu_1",
  "count": "_count_19hmu_8",
  "icon": "_icon_19hmu_14"
};